import script from "./GlobalChatsComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./GlobalChatsComponent.vue?vue&type=script&lang=ts&setup=true"

import "./GlobalChatsComponent.vue?vue&type=style&index=0&id=01dc871c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01dc871c"]])

export default __exports__